import BaseFormPresenter from "../../../base/BaseFormPresenter";

class EmailBlastViewPresenter extends BaseFormPresenter {
    
}

export default EmailBlastViewPresenter;
